import { render, staticRenderFns } from "./SelectPackage.vue?vue&type=template&id=4512689c&"
import script from "./SelectPackage.vue?vue&type=script&lang=js&"
export * from "./SelectPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4512689c')) {
      api.createRecord('4512689c', component.options)
    } else {
      api.reload('4512689c', component.options)
    }
    module.hot.accept("./SelectPackage.vue?vue&type=template&id=4512689c&", function () {
      api.rerender('4512689c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopInfo/components/TopUpPackage/components/SelectPackage.vue"
export default component.exports